import { createAccessLatch } from "@/shared/utils/accessLatch";

/**
 * One denial silences the surface for the session. Latched only by the reads that gate a page at mount
 * (pairs, order list), never by a write or by the order detail poll: a 403 there is about that request.
 */
export const cryptoSwapsAccessLatch = createAccessLatch();

export function cryptoSwapsPrincipalKey(
  userId: string | undefined,
  organizationId: string | undefined,
): string {
  return `${userId ?? "anon"}:${organizationId ?? "self"}`;
}
